import TypeBasculesController from './type.bascules.controller';

export default {
    template: require('./type.bascules.tpl.html'),
    controller: TypeBasculesController
};
